import React from 'react';
import StandardDialog from './shared/StandardDialog';
import { openDialogContainer } from 'nucleus-guestside-site/src/redux/modules/dialogContainer';
import CommonErrorDialogStyles from './styles/DialogError.less';
import { redirectToPage } from '../redux/pathInfo';
import { logoutRegistrant, logoutPlanner } from '../redux/registrantLogin/actions';
import getDialogContainerStyle from './shared/getDialogContainerStyle';
import { isLoggedIn } from '../redux/selectors/currentRegistrant';
import { fetchAndRetryIfServerBusy } from '@cvent/nucleus-networking';
import { GUEST_REGISTRATION, REGISTRATION } from '../redux/website/registrationProcesses';

export class SessionTimedOutError {}

/**
 * Creates a wrapper around `fetch` that
 *  1. tracks the 'Cvent-Session-Expiry' header in responses and opens a session timeout dialog at the indicated time
 *  2. opens the session timeout dialog when receiving a 401 response
 */
function createFetchWithSessionTimeoutDialog(store) {
  let timedOpen;
  function scheduleTimedOpen(msFromNow) {
    if (timedOpen) {
      window.clearTimeout(timedOpen);
    }
    timedOpen = window.setTimeout(() => {
      const state = store.getState();
      const hasPostRegLogin = isLoggedIn(state);
      const onRegistrationPage = REGISTRATION.isTypeOfCurrentPage(state) ||
        GUEST_REGISTRATION.isTypeOfCurrentPage(state);

      // If the session ending has user-visible effects,
      // i.e. their post reg pages disappear or they are on a registration page
      // then show the session time out message, otherwise, just silently clear their session
      if (hasPostRegLogin || onRegistrationPage) {
        store.dispatch(openSessionTimedOutDialog());
      } else {
        store.dispatch(logoutRegistrant());
      }
    }, msFromNow);
  }

  async function fetch(request) {
    const response = await fetchAndRetryIfServerBusy(request);
    if (response.status === 401) {
      store.dispatch(openSessionTimedOutDialog());
      throw new SessionTimedOutError();
    }
    if (response.headers && response.headers.has('Cvent-Session-Expiry')) {
      let msToExpiration = Number.parseInt(response.headers.get('Cvent-Session-Expiry'), 10);
      if (msToExpiration) {
        scheduleTimedOpen(msToExpiration);
      }
    }
    return response;
  }
  return fetch;
}

let _fetchWithSessionTimeout;
export function initializeFetchWithSessionTimeout(store) {
  _fetchWithSessionTimeout = createFetchWithSessionTimeoutDialog(store);
}

export function fetchWithSessionTimeout(request) {
  if (!_fetchWithSessionTimeout) {
    throw new Error('fetch with session timeout is not initialized');
  }
  return _fetchWithSessionTimeout(request);
}

function openSessionTimedOutDialog() {
  return (dispatch, getState) => {
    const { text: { translate }, userSession: { isPlanner }, plannerRegSettings: { exitUrl } } = getState();
    const exitSessionTimedOut = async () => {
      if (isPlanner) {
        await dispatch(logoutPlanner(exitUrl));
        return;
      }
      await dispatch(logoutRegistrant());
      dispatch(redirectToPage(''));
    };

    const dialog = (
      <StandardDialog
        onClose={exitSessionTimedOut}
        closeFallbackText={translate('EventGuestSide_StandardDialog_FallbackText_Close__resx')}
        message={translate('EventGuestside_KnownError_Error__resx')}
        subMessage={translate('Flex_SessionTimedout_Message__resx')}
        icon="error"
        iconModifier="error"
        classes={CommonErrorDialogStyles}
      />
    );
    return dispatch(openDialogContainer(dialog, exitSessionTimedOut, {
      classes: { dialogContainer: CommonErrorDialogStyles.dialogContainer },
      style: { dragContainer: getDialogContainerStyle(getState()) }
    }));
  };
}
